import { Link } from '@inertiajs/react';

export default function Breadcrumbs() {
    // Split URL Into Segments
    const segments = window.location.pathname.split('/').filter(Boolean);

    // Check If The Current Path Is Home
    const isHome = segments.length === 0;

    return (
        <nav
            className='text-md dark:text-gray-400 capitalize prose'
            aria-label='Breadcrumb'
        >
            {isHome ? (
                <span>home</span>
            ) : (
                <>
                    <Link prefetch href='/'>
                        home
                    </Link>
                    <span className='mx-2 text-inherit'>/</span>

                    {segments.map((segment, index) => {
                        const path =
                            '/' + segments.slice(0, index + 1).join('/');
                        const isLast = index === segments.length - 1;

                        return (
                            <span className='text-inherit' key={path}>
                                {isLast ? (
                                    <span>{segment}</span>
                                ) : (
                                    <>
                                        <Link prefetch href={path}>
                                            {segment}
                                        </Link>
                                        <span className='mx-2'>/</span>
                                    </>
                                )}
                            </span>
                        );
                    })}
                </>
            )}
        </nav>
    );
}
